
export default {
    /* 가맹점이 응답받는 postMessage 목록 */
    eventPrefix: 'CRX_PSEVT_',
    events: {
        SETUP: 'CRX_PSEVT_SETUP',
        CHALLENGE: 'CRX_PSEVT_CHALLENGE',
        READY: 'CRX_PSEVT_READY',
        VALIDATION_CHANGED: 'CRX_PSEVT_VALI_CHED',
        SUBMITTED: 'CRX_PSEVT_SUBMITTED',
        SUBMITED: 'CRX_PSEVT_SUBMITED', // 처음에 잘못 설정된 값
        TOKENIZED: 'CRX_PSEVT_TOKENIZED',
        RESERVED: 'CRX_PSEVT_RESERVED',
        RETRIVED: 'CRX_PSEVT_RETRIVED',
        ERROR: 'CRX_PSEVT_ERROR',
    },
    /* 서버로 전달하는 postMessage 목록 */
    toServerEvents: {
        BIND: 'CRX_PSEVT_BIND',
        SUBMIT: 'CRX_PSEVT_SUBMIT',
        RESERVE: 'CRX_PSEVT_RESERVE',
        RETRIVE: 'CRX_PSEVT_RETRIVE',
    },
};
